module.exports = __webpack_public_path__ + "static/img/15023B_1_R_20211024_fit.bea76d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15023B_1_R_20211024_fit.png
// module id = gTKZ
// module chunks = 0